/**
 * Region every deactivated user is moved to. The admin resolves it by name
 * before saving; the API asserts an inactive user belongs to it and nothing
 * else.
 */
export const INACTIVE_USER_REGION_NAME = 'Inactive User';
